import {Line} from "../type";

export const prettierLog = (data: {
    msg: string;
    type?: 'info' | 'warn' | 'error' | 'success';
}) => {
    const { msg, type } = data;
    if (type === 'success') {
        console.log(
            `%c ` +
            `【Images Agent】${new Date().toLocaleString()}` +
            ` %c ${msg} ` +
            `%c`,
            'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );
    } else {
        console[type || 'info'](
            `【Images Agent】${new Date().toLocaleString()}`,
            msg
        );
    }
};

export const tryCatchUtil = (
    executeFunc: () => void,
    errorCallBackFunc: (error: Error) => void,
    finallyFunc = () => {}
) => {
    try {
        executeFunc();
    }catch (error: any) {
        errorCallBackFunc(error);
    }finally {
        finallyFunc();
    }
}

export const basicDownloadImage = (imgUrl: string, downloadName: string, needRevoke = true) => {
    const a = document.createElement('a');
    a.href = imgUrl;
    a.download = downloadName;
    document.body.appendChild(a);
    a.click();
    if (needRevoke) URL.revokeObjectURL(imgUrl);
    a.remove();
}

/**
 * 鼠标在canvas上画线条
 */
export const drawLines = (
    ctx: CanvasRenderingContext2D,
    lines: Line[],
    color = '#FF8D00'
) => {
    // ctx.globalCompositeOperation = 'copy';// 控制绘图混合模式的属性

    ctx.strokeStyle = color;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    lines.forEach(line => {
        if (!line?.pts.length) {
            return
        }
        ctx.lineWidth = line.lineWidth || 6
        ctx.beginPath()
        ctx.moveTo(line.pts[0].x, line.pts[0].y)
        line.pts.forEach(pt => ctx.lineTo(pt.x, pt.y))
        ctx.stroke()
    })
}

/**
 * Parse HH:mm:ss to seconds
 * @param hhmmss
 */
export const hhmmssToSeconds = (hhmmss: string) => {
    const [hours, minutes, seconds] = hhmmss.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}
